export default function EventCardStartTime({ timeIn }) {
  return (
    <div className="mt-4 flex h-auto w-full flex-row-reverse gap-4 desktop-lg:mt-0 desktop-lg:w-fit">
      {timeIn ? (
        <div className="flex h-auto w-[50%] rounded-md border border-neutral-blue-700 bg-neutral-blue-800 px-[5px] desktop-lg:w-[150px]">
          <div className="xl: desktop-sm:py=2 mx-auto flex flex-col self-center py-[24px]">
            <div className="self-center text-center text-[18px] text-neutral-blue-500">
              Start time
            </div>
            <div className="self-center text-[23px] text-white">
              <p className="text-center font-bold">
                {timeIn && timeIn.format('HH:mm')}
              </p>
            </div>
            <div className="self-center text-neutral-blue-500">
              <p className="text-center text-[18px]">
                {timeIn && timeIn.format('z')}
              </p>
            </div>
          </div>
        </div>
      ) : null}
      {timeIn ? (
        <div className="flex h-auto w-[50%] rounded-md border border-neutral-blue-700 bg-neutral-blue-800 px-[5px] desktop-lg:w-[150px]">
          <div className="mx-auto flex flex-col self-center py-[24px]">
            <div className="self-center text-center text-[18px] text-neutral-blue-500">
              Start date
            </div>
            <div className="self-center text-center text-[23px] font-bold text-white">
              {timeIn['$D']}
            </div>
            <div className="self-center text-center text-[18px] text-neutral-blue-500">
              {timeIn.format('MMMM YYYY')}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}
